import Add from "@ht/shared/fonts/deos-pis/add";
import AgentAvailable from "@ht/shared/fonts/deos-pis/agent-available";
import AgentUnavailable from "@ht/shared/fonts/deos-pis/agent-unavailable";
import Alert from "@ht/shared/fonts/deos-pis/alert";
import ArrowDown from "@ht/shared/fonts/deos-pis/arrow-down";
import ArrowLeft from "@ht/shared/fonts/deos-pis/arrow-left";
import ArrowLeftRight from "@ht/shared/fonts/deos-pis/arrow-left-right";
import ArrowRight from "@ht/shared/fonts/deos-pis/arrow-right";
import ArrowUp from "@ht/shared/fonts/deos-pis/arrow-up";
import Arsi from "@ht/shared/fonts/deos-pis/logo-arsi";
import Attachment from "@ht/shared/fonts/deos-pis/attachment";
import Award from "@ht/shared/fonts/deos-pis/award";
import Bell from "@ht/shared/fonts/deos-pis/bell";
import Bold from "@ht/shared/fonts/deos-pis/bold";
import Briefcase from "@ht/shared/fonts/deos-pis/briefcase";
import Budget from "@ht/shared/fonts/deos-pis/budget-icon";
import CalenderOutlineXS from "@ht/shared/fonts/deos-pis/calendar-outline-extra-small";
import Calender from "@ht/shared/fonts/deos-pis/calendar";
import CallHangup from "@ht/shared/fonts/deos-pis/call-hangup";
import CallMissed from "@ht/shared/fonts/deos-pis/call-missed";
import CallOutline from "@ht/shared/fonts/deos-pis/call-outline";
import CallOutlineSM from "@ht/shared/fonts/deos-pis/call-outline-small";
import CallOutlineXS from "@ht/shared/fonts/deos-pis/call-outline-extra-small";
import Call from "@ht/shared/fonts/deos-pis/call";
import Camera from "@ht/shared/fonts/deos-pis/camera";
import ChannelOutlineXS from "@ht/shared/fonts/deos-pis/channel-outline-extra-small";
import ChatMultiBubble from "@ht/shared/fonts/deos-pis/chat-multi-bubble";
import ChatOutline from "@ht/shared/fonts/deos-pis/chat-outline";
import ChatOutlineSM from "@ht/shared/fonts/deos-pis/chat-outline-small";
import ChatPlus from "@ht/shared/fonts/deos-pis/chat-plus";
import ChatResolved from "@ht/shared/fonts/deos-pis/chat-resolve";
import ChatSuccess from "@ht/shared/fonts/deos-pis/chat-success";
import ChatUnresolved from "@ht/shared/fonts/deos-pis/chat-unresolved";
import Chat from "@ht/shared/fonts/deos-pis/chat";
import CheckCircle from "@ht/shared/fonts/deos-pis/check-circle";
import CheckCircleBold from "@ht/shared/fonts/deos-pis/check-circle-bold";
import CheckSquare from "@ht/shared/fonts/deos-pis/check-square";
import ChevronDown from "@ht/shared/fonts/deos-pis/chevron-down";
import ChevronLeft from "@ht/shared/fonts/deos-pis/chevron-left";
import ChevronRight from "@ht/shared/fonts/deos-pis/chevron-right";
import ChevronUp from "@ht/shared/fonts/deos-pis/chevron-up";
import ChevronVertical from "@ht/shared/fonts/deos-pis/chevron-vertical";
import Clock from "@ht/shared/fonts/deos-pis/clock";
import Close from "@ht/shared/fonts/deos-pis/close";
import Dashboard from "@ht/shared/fonts/deos-pis/dashboard";
import Dollar from "@ht/shared/fonts/deos-pis/dollar";
import Dot from "@ht/shared/fonts/deos-pis/dot";
import Dots from "@ht/shared/fonts/deos-pis/dots";
import DownloadCloud from "@ht/shared/fonts/deos-pis/download-cloud";
import Download from "@ht/shared/fonts/deos-pis/download";
import DragDrop from "@ht/shared/fonts/deos-pis/drag-drop";
import Edit from "@ht/shared/fonts/deos-pis/edit";
import EmojiSad from "@ht/shared/fonts/deos-pis/emoji-sad";
import ExitFullScreen from "@ht/shared/fonts/deos-pis/exit-fullscreen";
import EyeOff from "@ht/shared/fonts/deos-pis/eye-off";
import Eye from "@ht/shared/fonts/deos-pis/eye";
import Facebook from "@ht/shared/fonts/deos-pis/facebook";
import Female from "@ht/shared/fonts/deos-pis/female";
import File from "@ht/shared/fonts/deos-pis/file";
import FileText from "@ht/shared/fonts/deos-pis/file-text";
import FileUpload from "@ht/shared/fonts/deos-pis/fileupload";
import Filter from "@ht/shared/fonts/deos-pis/filter";
import FullScreen from "@ht/shared/fonts/deos-pis/fullscreen";
import Gear from "@ht/shared/fonts/deos-pis/gear";
import Gender from "@ht/shared/fonts/deos-pis/gender";
import Group from "@ht/shared/fonts/deos-pis/group";
import Heart from "@ht/shared/fonts/deos-pis/Heart";
import History from "@ht/shared/fonts/deos-pis/history";
import Home from "@ht/shared/fonts/deos-pis/home";
import Image from "@ht/shared/fonts/deos-pis/image";
import ImageIcon from "@ht/shared/fonts/deos-pis/image-icon";
import Info from "@ht/shared/fonts/deos-pis/info";
import Instagram from "@ht/shared/fonts/deos-pis/instagram";
import Key from "@ht/shared/fonts/deos-pis/key";
import Layout from "@ht/shared/fonts/deos-pis/layout";
import LightBulb from "@ht/shared/fonts/deos-pis/light-bulb";
import Lightning from "@ht/shared/fonts/deos-pis/lightning";
import Line from "@ht/shared/fonts/deos-pis/line";
import Link from "@ht/shared/fonts/deos-pis/link";
import List from "@ht/shared/fonts/deos-pis/list";
import List2 from "@ht/shared/fonts/deos-pis/list2";
import Loading from "@ht/shared/fonts/deos-pis/loading";
import Logout from "@ht/shared/fonts/deos-pis/logout";
import MailOutlineXS from "@ht/shared/fonts/deos-pis/mail-outline-extra-small";
import Mail from "@ht/shared/fonts/deos-pis/mail";
import Male from "@ht/shared/fonts/deos-pis/male";
import Megaphone from "@ht/shared/fonts/deos-pis/megaphone";
import MessageSquare from "@ht/shared/fonts/deos-pis/message-square";
import MicMute from "@ht/shared/fonts/deos-pis/mic-mute";
import Mic from "@ht/shared/fonts/deos-pis/mic";
import Monitor from "@ht/shared/fonts/deos-pis/monitor";
import Monitoring from "@ht/shared/fonts/deos-pis/monitoring";
import MoreHorizontal from "@ht/shared/fonts/deos-pis/more-horizotal";
import MoreVertical from "@ht/shared/fonts/deos-pis/more-vertical";
import MoveOut from "@ht/shared/fonts/deos-pis/move-out";
import Move from "@ht/shared/fonts/deos-pis/move";
import Confirm from "@ht/shared/fonts/deos-pis/msg-confirm";
import Error from "@ht/shared/fonts/deos-pis/msg-error";
import Success from "@ht/shared/fonts/deos-pis/msg-success";
import Warning from "@ht/shared/fonts/deos-pis/msg-warning";
import Mute from "@ht/shared/fonts/deos-pis/mute";
import NoteOutlineXS from "@ht/shared/fonts/deos-pis/note-outline-extra-small";
import OpenInBrowser from "@ht/shared/fonts/deos-pis/open-in-browser";
import Package from "@ht/shared/fonts/deos-pis/package";
import Pause from "@ht/shared/fonts/deos-pis/pause";
import Pencil from "@ht/shared/fonts/deos-pis/pencil";
import PhoneCallInbound from "@ht/shared/fonts/deos-pis/phone-call-inbound";
import PhoneCallOutbound from "@ht/shared/fonts/deos-pis/phone-call-outbound";
import PhoneMissed from "@ht/shared/fonts/deos-pis/phone-missed";
import PhoneReject from "@ht/shared/fonts/deos-pis/phone-reject";
import PhoneRing from "@ht/shared/fonts/deos-pis/phone-ring";
import Phone from "@ht/shared/fonts/deos-pis/phone";
import PieChart from "@ht/shared/fonts/deos-pis/pie-chart";
import Pin from "@ht/shared/fonts/deos-pis/pin";
import Pin2 from "@ht/shared/fonts/deos-pis/pin2";
import PlayCircle from "@ht/shared/fonts/deos-pis/play-circle";
import Play from "@ht/shared/fonts/deos-pis/play";
import Plus from "@ht/shared/fonts/deos-pis/plus";
import ProfilePicture from "@ht/shared/fonts/deos-pis/pp";
import Pray from "@ht/shared/fonts/deos-pis/pray";
import Profile from "@ht/shared/fonts/deos-pis/profile";
import RadioHalf from "@ht/shared/fonts/deos-pis/radio-half";
import Radio from "@ht/shared/fonts/deos-pis/radio";
import RadioNone from "@ht/shared/fonts/deos-pis/radio-none";
import Refresh from "@ht/shared/fonts/deos-pis/refresh";
import Remove from "@ht/shared/fonts/deos-pis/remove";
import Search from "@ht/shared/fonts/deos-pis/search";
import Send from "@ht/shared/fonts/deos-pis/send";
import Sent from "@ht/shared/fonts/deos-pis/sent";
import Setting from "@ht/shared/fonts/deos-pis/setting";
import ShareScreen from "@ht/shared/fonts/deos-pis/share-screen";
import Shield from "@ht/shared/fonts/deos-pis/shield-outline-extra-small";
import SignalBar from "@ht/shared/fonts/deos-pis/signal-bar";
import Signal from "@ht/shared/fonts/deos-pis/signal";
import Slider from "@ht/shared/fonts/deos-pis/slider";
import SoundWave from "@ht/shared/fonts/deos-pis/sound-wave";
import Subtitle from "@ht/shared/fonts/deos-pis/subtitle";
import System from "@ht/shared/fonts/deos-pis/system";
import Task from "@ht/shared/fonts/deos-pis/task";
import Teams from "@ht/shared/fonts/deos-pis/teams";
import TransferIn from "@ht/shared/fonts/deos-pis/transfer-in";
import TransferOut from "@ht/shared/fonts/deos-pis/transfer-out";
import Trash from "@ht/shared/fonts/deos-pis/trash";
import Twitter from "@ht/shared/fonts/deos-pis/twitter";
import UploadDoc from "@ht/shared/fonts/deos-pis/upload-doc";
import Upload from "@ht/shared/fonts/deos-pis/upload";
import UserXS from "@ht/shared/fonts/deos-pis/user-outline-extra-small";
import User from "@ht/shared/fonts/deos-pis/user-outline";
import Users from "@ht/shared/fonts/deos-pis/users";
import VideoCameraOff from "@ht/shared/fonts/deos-pis/video-camera-off";
import VideoCameraOn from "@ht/shared/fonts/deos-pis/video-camera";
import VideoOff from "@ht/shared/fonts/deos-pis/video-off";
import VideoOn from "@ht/shared/fonts/deos-pis/video-on";
import VideoSM from "@ht/shared/fonts/deos-pis/video-outline-small";
import Video from "@ht/shared/fonts/deos-pis/video-outline";
import Volume from "@ht/shared/fonts/deos-pis/volume-2";
import Whatsapp from "@ht/shared/fonts/deos-pis/whatsapp";
import X from "@ht/shared/fonts/deos-pis/x";

export const icons = [
  { name: "add", component: Add },
  { name: "agent-available", component: AgentAvailable },
  { name: "agent-unavailable", component: AgentUnavailable },
  { name: "alert", component: Alert },
  { name: "arrow-down", component: ArrowDown },
  { name: "arrow-left", component: ArrowLeft },
  { name: "arrow-left-right", component: ArrowLeftRight },
  { name: "arrow-right", component: ArrowRight },
  { name: "arrow-up", component: ArrowUp },
  { name: "arsi", component: Arsi },
  { name: "attachment", component: Attachment },
  { name: "award", component: Award },
  { name: "bell", component: Bell },
  { name: "bold", component: Bold },
  { name: "briefcase", component: Briefcase },
  { name: "budget", component: Budget },
  { name: "calendar-outline-xs", component: CalenderOutlineXS },
  { name: "calendar", component: Calender },
  { name: "call-hangup", component: CallHangup },
  { name: "call-missed", component: CallMissed },
  { name: "call-outline", component: CallOutline },
  { name: "call-outline-sm", component: CallOutlineSM },
  { name: "call-outline-xs", component: CallOutlineXS },
  { name: "call", component: Call },
  { name: "camera", component: Camera },
  { name: "channel-outline-xs", component: ChannelOutlineXS },
  { name: "chat-multi-bubble", component: ChatMultiBubble },
  { name: "chat-outline", component: ChatOutline },
  { name: "chat-outline-sm", component: ChatOutlineSM },
  { name: "chat-plus", component: ChatPlus },
  { name: "chat-resolved", component: ChatResolved },
  { name: "chat-success", component: ChatSuccess },
  { name: "chat-unresolved", component: ChatUnresolved },
  { name: "chat", component: Chat },
  { name: "check-circle", component: CheckCircle },
  { name: "check-circle-bold", component: CheckCircleBold },
  { name: "check-square", component: CheckSquare },
  { name: "chevron-down", component: ChevronDown },
  { name: "chevron-left", component: ChevronLeft },
  { name: "chevron-right", component: ChevronRight },
  { name: "chevron-up", component: ChevronUp },
  { name: "chevron-vertical", component: ChevronVertical },
  { name: "clock", component: Clock },
  { name: "close", component: Close },
  { name: "dashboard", component: Dashboard },
  { name: "dollar", component: Dollar },
  { name: "dot", component: Dot },
  { name: "dots", component: Dots },
  { name: "download-cloud", component: DownloadCloud },
  { name: "download", component: Download },
  { name: "drag-drop", component: DragDrop },
  { name: "edit", component: Edit },
  { name: "emoji-sad", component: EmojiSad },
  { name: "exit-fullscreen", component: ExitFullScreen },
  { name: "eye-off", component: EyeOff },
  { name: "eye", component: Eye },
  { name: "facebook", component: Facebook },
  { name: "female", component: Female },
  { name: "file", component: File },
  { name: "file-text", component: FileText },
  { name: "file-upload", component: FileUpload },
  { name: "filter", component: Filter },
  { name: "fullscreen", component: FullScreen },
  { name: "gear", component: Gear },
  { name: "gender", component: Gender },
  { name: "group", component: Group },
  { name: "heart", component: Heart },
  { name: "history", component: History },
  { name: "home", component: Home },
  { name: "image", component: Image },
  { name: "image-icon", component: ImageIcon },
  { name: "info", component: Info },
  { name: "instagram", component: Instagram },
  { name: "key", component: Key },
  { name: "layout", component: Layout },
  { name: "lightbulb", component: LightBulb },
  { name: "lightning", component: Lightning },
  { name: "line", component: Line },
  { name: "link", component: Link },
  { name: "list", component: List },
  { name: "list2", component: List2 },
  { name: "loading", component: Loading },
  { name: "logout", component: Logout },
  { name: "mail-outline-xs", component: MailOutlineXS },
  { name: "mail", component: Mail },
  { name: "male", component: Male },
  { name: "megaphone", component: Megaphone },
  { name: "message-square", component: MessageSquare },
  { name: "mic-mute", component: MicMute },
  { name: "mic", component: Mic },
  { name: "monitor", component: Monitor },
  { name: "monitoring", component: Monitoring },
  { name: "more-horizontal", component: MoreHorizontal },
  { name: "more-vertical", component: MoreVertical },
  { name: "move-out", component: MoveOut },
  { name: "move", component: Move },
  { name: "confirm", component: Confirm },
  { name: "error", component: Error },
  { name: "success", component: Success },
  { name: "warning", component: Warning },
  { name: "mute", component: Mute },
  { name: "note-outline-xs", component: NoteOutlineXS },
  { name: "open-browser", component: OpenInBrowser },
  { name: "package", component: Package },
  { name: "pause", component: Pause },
  { name: "pencil", component: Pencil },
  { name: "phone-call-inbound", component: PhoneCallInbound },
  { name: "phone-call", component: PhoneCallOutbound },
  { name: "phone-missed", component: PhoneMissed },
  { name: "phone-reject", component: PhoneReject },
  { name: "phone-ring", component: PhoneRing },
  { name: "phone", component: Phone },
  { name: "pie-chart", component: PieChart },
  { name: "pin", component: Pin },
  { name: "pin-2", component: Pin2 },
  { name: "play-circle", component: PlayCircle },
  { name: "play", component: Play },
  { name: "plus", component: Plus },
  { name: "profile-picture", component: ProfilePicture },
  { name: "pray", component: Pray },
  { name: "profile", component: Profile },
  { name: "radio-intermediate", component: RadioHalf },
  { name: "radio", component: Radio },
  { name: "radio-none", component: RadioNone },
  { name: "refresh", component: Refresh },
  { name: "remove", component: Remove },
  { name: "search", component: Search },
  { name: "send", component: Send },
  { name: "sent", component: Sent },
  { name: "setting", component: Setting },
  { name: "share-screen", component: ShareScreen },
  { name: "shield", component: Shield },
  { name: "signal-bar", component: SignalBar },
  { name: "signal", component: Signal },
  { name: "slider", component: Slider },
  { name: "soundwave", component: SoundWave },
  { name: "subtitle", component: Subtitle },
  { name: "system", component: System },
  { name: "task", component: Task },
  { name: "teams", component: Teams },
  { name: "transfer-in", component: TransferIn },
  { name: "transfer-out", component: TransferOut },
  { name: "trash", component: Trash },
  { name: "twitter", component: Twitter },
  { name: "upload-document", component: UploadDoc },
  { name: "upload", component: Upload },
  { name: "user-xs", component: UserXS },
  { name: "user", component: User },
  { name: "users", component: Users },
  { name: "video-camera-off", component: VideoCameraOff },
  { name: "video-camera-on", component: VideoCameraOn },
  { name: "video-off", component: VideoOff },
  { name: "video-on", component: VideoOn },
  { name: "video-sm", component: VideoSM },
  { name: "video", component: Video },
  { name: "volume", component: Volume },
  { name: "whatsapp", component: Whatsapp },
  { name: "X", component: X },
];
